import { useGetDiscoveryShareDate } from 'api';

type UseProfileDiscoveryShareDateProps = {
  profileId: string;
  enabled?: boolean;
};

export const useProfileDiscoveryShareDate = ({
  profileId,
  enabled = true,
}: UseProfileDiscoveryShareDateProps) => {
  const { data, isLoading, isError } = useGetDiscoveryShareDate(profileId, {
    enabled,
  });

  return {
    lastSharedAt: data,
    isDiscoveryShareDateLoading: isLoading,
    isDiscoveryShareDateError: isError,
  };
};
